/**
 * State used in rendering DialogSurface
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
